export const getCredencials = () =>{
    return {
        urlServer : process.env.REACT_APP_URL_SERVER,
        apiId : process.env.REACT_APP_API_ID,
        jsKey : process.env.REACT_APP_JS_KEY
    }
}